// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Menu.js with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Button, Menu, MenuItem, MenuGroup} from '@sail/ui';

const basic = {
  rendered: (
    <Menu trigger={<Button>Menu</Button>}>
      <MenuItem>Edit</MenuItem>
      <MenuItem>Copy</MenuItem>
      <MenuItem>Paste</MenuItem>
    </Menu>
  ),
  source: `<Menu trigger={<Button>Menu</Button>}>
  <MenuItem>Edit</MenuItem>
  <MenuItem>Copy</MenuItem>
  <MenuItem>Paste</MenuItem>
</Menu>`,
};
const items = {
  rendered: (
    <Menu aria-label="Menu">
      <MenuItem>Edit</MenuItem>
      <MenuItem disabled>Copy</MenuItem>
      <MenuItem>Paste</MenuItem>
    </Menu>
  ),
  source: `<Menu aria-label="Menu">
  <MenuItem>Edit</MenuItem>
  <MenuItem disabled>Copy</MenuItem>
  <MenuItem>Paste</MenuItem>
</Menu>`,
};
const groups = {
  rendered: (
    <Menu aria-label="Menu">
      <MenuGroup title="Actions">
        <MenuItem>Duplicate</MenuItem>
        <MenuItem>Edit</MenuItem>
        <MenuItem>Cancel</MenuItem>
      </MenuGroup>
      <MenuGroup title="Connections">
        <MenuItem>View customer</MenuItem>
        <MenuItem>View subscription</MenuItem>
      </MenuGroup>
    </Menu>
  ),
  source: `<Menu aria-label="Menu">
  <MenuGroup title="Actions">
    <MenuItem>Duplicate</MenuItem>
    <MenuItem>Edit</MenuItem>
    <MenuItem>Cancel</MenuItem>
  </MenuGroup>
  <MenuGroup title="Connections">
    <MenuItem>View customer</MenuItem>
    <MenuItem>View subscription</MenuItem>
  </MenuGroup>
</Menu>`,
};
const events = {
  rendered: (
    <Menu
      aria-label="Menu"
      onAction={(id) => console.log(`Item ${id} was pressed.`)}
    >
      <MenuGroup title="Actions">
        <MenuItem id="duplicate">Duplicate</MenuItem>
        <MenuItem id="edit">Edit</MenuItem>
        <MenuItem id="cancel">Cancel</MenuItem>
      </MenuGroup>
      <MenuGroup title="Connections">
        <MenuItem
          id="View customer"
          onAction={() => console.log(`View customer was pressed.`)}
        >
          View customer
        </MenuItem>
        <MenuItem id="View subscription">View subscription</MenuItem>
      </MenuGroup>
    </Menu>
  ),
  source: `<Menu
  aria-label="Menu"
  onAction={(id) => console.log(\`Item \${id} was pressed.\`)}
>
  <MenuGroup title="Actions">
    <MenuItem id="duplicate">Duplicate</MenuItem>
    <MenuItem id="edit">Edit</MenuItem>
    <MenuItem id="cancel">Cancel</MenuItem>
  </MenuGroup>
  <MenuGroup title="Connections">
    <MenuItem
      id="View customer"
      onAction={() => console.log(\`View customer was pressed.\`)}
    >
      View customer
    </MenuItem>
    <MenuItem id="View subscription">View subscription</MenuItem>
  </MenuGroup>
</Menu>`,
};
const trigger = {
  rendered: (
    <Menu trigger={<Button>Menu</Button>}>
      <MenuGroup title="Actions">
        <MenuItem>Duplicate</MenuItem>
        <MenuItem disabled>Edit</MenuItem>
        <MenuItem>Cancel</MenuItem>
      </MenuGroup>
      <MenuGroup title="Connections">
        <MenuItem>View customer</MenuItem>
        <MenuItem>View subscription</MenuItem>
      </MenuGroup>
    </Menu>
  ),
  source: `<Menu trigger={<Button>Menu</Button>}>
  <MenuGroup title="Actions">
    <MenuItem>Duplicate</MenuItem>
    <MenuItem disabled>Edit</MenuItem>
    <MenuItem>Cancel</MenuItem>
  </MenuGroup>
  <MenuGroup title="Connections">
    <MenuItem>View customer</MenuItem>
    <MenuItem>View subscription</MenuItem>
  </MenuGroup>
</Menu>`,
};
export const MenuExamples = {
  basic,
  items,
  groups,
  events,
  trigger,
};
